var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInventoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #2a4265;\n      }\n\n      .cls-4 {\n        fill: url(#New_Gradient_Swatch_1-2);\n        stroke: url(#New_Gradient_Swatch_1-3);\n      }\n\n      .cls-4, .cls-2, .cls-5 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke: #2a4265;\n        stroke-width: 37px;\n      }\n\n      .cls-5 {\n        fill: none;\n        stroke: url(#New_Gradient_Swatch_1);\n        stroke-width: 27px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1",
    "data-name": "New Gradient Swatch 1",
    x1: 24.79,
    y1: 547.33,
    x2: 1048.88,
    y2: 547.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c81515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bc1111"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-2",
    "data-name": "New Gradient Swatch 1",
    x1: 465.32,
    y1: 620.46,
    x2: 607.97,
    y2: 620.46,
    xlinkHref: "#New_Gradient_Swatch_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-3",
    "data-name": "New Gradient Swatch 1",
    x1: 464.82,
    y1: 620.46,
    x2: 608.47,
    y2: 620.46,
    xlinkHref: "#New_Gradient_Swatch_1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 536.83,
    cy: 547.33,
    r: 451
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 536.83,
    cy: 547.33,
    r: 498.55
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Inventory"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m831.2,379.02h-170.28v-69.7c0-6.8-2.76-13.45-7.56-18.26-4.81-4.81-11.46-7.56-18.26-7.56h-196.9c-6.8,0-13.45,2.76-18.26,7.56-4.81,4.81-7.57,11.46-7.57,18.26v69.7h-170.29c-18.27,0-33.08,15.43-33.08,34.46v35.54h655.28v-35.54c0-19.03-14.81-34.46-33.08-34.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 453.55,
    y: 335.14,
    width: 166.18,
    height: 40.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m260.34,747.8c1.08,16.46,16.29,29.73,33.98,29.73h484.65c17.69,0,32.9-13.26,33.98-29.73l20.06-285.86H240.28l20.06,285.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m536.64,507.24c62.53,0,113.22,50.69,113.22,113.22s-50.69,113.22-113.22,113.22-113.22-50.69-113.22-113.22,50.69-113.22,113.22-113.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "508.9 691.79 564.4 691.79 564.4 648.2 607.97 648.2 607.97 592.69 564.4 592.69 564.4 549.13 508.9 549.13 508.9 592.69 465.32 592.69 465.32 648.2 508.9 648.2 508.9 691.79"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryIcon);
export default __webpack_public_path__ + "static/media/Inventory-Icon.978eb6ddf32d49912c50fce5496eb6d2.svg";
export { ForwardRef as ReactComponent };